// ═══ ARTICLE RESEARCH — BATCH B · REAL PAGE SCREENSHOTS (Dev2, 2026-07-14) ══════
// Second wave of the reference article wall: AI-agent companies, analysts/VC, and
// labs — the market we compete in. Each entry is a real Playwright capture of the
// live article page (1280x2000 @2x), hosted on R2. Leo wires batch-a + batch-b
// into the board. 95 article pages across 13 publishers.
export type BatchBArticle = { title: string; url: string; img: string };
export type BatchBColumn = { company: string; articles: BatchBArticle[] };

export const articlesBatchB: BatchBColumn[] = [
  {
    "company": "Sierra",
    "articles": [
      {
        "title": "Meet Sierra, the conversational AI platform for businesses",
        "url": "https://sierra.ai/blog/introducing-sierra",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/be04b285-0f79-43a2-acdc-a0a5c7d0f1ac-b-sierra-introducing-thumb.jpg"
      },
      {
        "title": "Better customer experiences. Built on Sierra",
        "url": "https://sierra.ai/blog/better-customer-experiences-built-on-sierra",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4e266765-5fb9-4feb-aa20-36a32d288da2-b-sierra-better-cx-thumb.jpg"
      },
      {
        "title": "AI agents drive customer retention",
        "url": "https://sierra.ai/blog/ai-agents-drive-customer-retention",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/db080751-f146-4618-8e44-e97bb18cc06e-b-sierra-retention-thumb.jpg"
      },
      {
        "title": "There's an agent for that, and it runs on Sierra",
        "url": "https://sierra.ai/blog/theres-an-agent-for-that-and-it-runs-on-sierra",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cf993da4-a750-41d3-aed1-bb713bbd9e75-b-sierra-agent-for-that-thumb.jpg"
      },
      {
        "title": "Serving customer experience and engineering teams — all from one platform",
        "url": "https://sierra.ai/blog/serving-customer-experience-and-engineering-teams-all-from-one-platform",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cc633e8c-6bd4-446a-88b8-c99f9d3b2ff9-b-sierra-one-platform-thumb.jpg"
      },
      {
        "title": "Fast to build, faster to impact",
        "url": "https://sierra.ai/blog/fast-to-build-faster-to-impact",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8c6033b9-5cbb-4f94-98a5-f5043e35b618-b-sierra-fast-to-build-thumb.jpg"
      },
      {
        "title": "Agents as a service",
        "url": "https://sierra.ai/blog/agents-as-a-service",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/06d81c74-7582-4a05-bafc-577e353e7f8b-b-sierra-agents-as-a-service-thumb.jpg"
      },
      {
        "title": "AI agents in action (Brex)",
        "url": "https://sierra.ai/blog/ai-agents-in-action-brex",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/110696d2-f900-434a-8a29-3e61e47fdef2-b-sierra-brex-thumb.jpg"
      },
      {
        "title": "Outcome-based pricing for AI Agents",
        "url": "https://sierra.ai/blog/outcome-based-pricing-for-ai-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/943a7a1b-d29a-4170-9623-1f11b02e3285-b-sierra-outcome-pricing-thumb.jpg"
      },
      {
        "title": "Sierra speaks",
        "url": "https://sierra.ai/blog/sierra-speaks",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/31270815-7ee3-47cb-bf1f-85424a6d213e-b-sierra-speaks-thumb.jpg"
      }
    ]
  },
  {
    "company": "Cresta",
    "articles": [
      {
        "title": "Cresta Expands Generative AI Solutions for the Contact Center",
        "url": "https://cresta.com/blog/cresta-expands-generative-ai-solutions-for-the-contact-center/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ec61c3d1-523e-4352-9ed2-0f334c960400-b-cresta-expands-genai-thumb.jpg"
      },
      {
        "title": "The Future of the Contact Center: AI Predictions for 2025",
        "url": "https://cresta.com/blog/the-future-of-the-contact-center-ai-predictions-for-2025",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f5856b20-2bbf-4c9f-bd61-39a9ee22cdf1-b-cresta-predictions-2025-thumb.jpg"
      },
      {
        "title": "Cresta Is Now on Google Cloud Marketplace",
        "url": "https://cresta.com/blog/cresta-is-now-on-google-cloud-marketplace-making-ai-for-contact-centers-easier-than-ever",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/a6dc594a-33fe-409d-ac15-20773415dadd-b-cresta-google-cloud-thumb.jpg"
      },
      {
        "title": "Three Ways AI Supercharges Your Contact Center",
        "url": "https://cresta.com/blog/three-ways-ai-supercharges-your-contact-center",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d16a69e0-da9a-4d39-b744-8d7c69fc43d4-b-cresta-three-ways-thumb.jpg"
      },
      {
        "title": "Why AI is the Missing Link in Contact Center Quality Management & Compliance",
        "url": "https://cresta.com/blog/why-ai-is-the-missing-link-in-contact-center-quality-management-compliance",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/7a3d04eb-c159-4d9b-8181-7d6d4dc07c09-b-cresta-missing-link-thumb.jpg"
      },
      {
        "title": "Contact Center AI: Fuel Lasting Success in Modern CX",
        "url": "https://cresta.com/blog/contact-center-ai-fuel-lasting-success-in-modern-cx",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8bcf1f98-8b4f-4523-af6a-e253fb15fddd-b-cresta-modern-cx-thumb.jpg"
      },
      {
        "title": "Transforming the Contact Center: The Power of Automation in the Age of AI",
        "url": "https://cresta.com/blog/transforming-the-contact-center-the-power-of-automation-in-the-age-of-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ff5d5fb7-c6e0-4439-aa94-6a2d1a4a23a0-b-cresta-transforming-thumb.jpg"
      },
      {
        "title": "Seven Predictions for Generative AI in the Contact Center",
        "url": "https://cresta.com/blog/generative-ai-in-the-contact-center-seven-predictions/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/41684fee-478f-4f22-a94e-1b921e753b08-b-cresta-seven-predictions-thumb.jpg"
      },
      {
        "title": "Announcing Cresta Voice Virtual Agent: What Sets It Apart",
        "url": "https://cresta.com/blog/announcing-cresta-voice-virtual-agent-what-sets-it-apart-what-the-market-is-getting-wrong",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b53ed3e6-b949-4070-9c83-0463d3779419-b-cresta-voice-virtual-agent-thumb.jpg"
      },
      {
        "title": "Voice AI Agents: Why Decentralized Architectures Can Outperform Central Orchestrators",
        "url": "https://cresta.com/blog/voice-ai-agents-for-customer-experience-why-decentralized-agent-architectures-can-outperform-central-orchestrators",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/715dcad9-de4b-4755-9977-23782101d8ec-b-cresta-decentralized-thumb.jpg"
      }
    ]
  },
  {
    "company": "Decagon",
    "articles": [
      {
        "title": "Complete AI customer support setup: Tools, integrations, and launch strategy",
        "url": "https://decagon.ai/blog/ai-customer-support-setup",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5e5a0de6-e85e-4b82-82e5-7b3e0c91dc9a-b-decagon-support-setup-thumb.jpg"
      },
      {
        "title": "What AI customer support agents actually do",
        "url": "https://decagon.ai/blog/ai-customer-service-agent-capabilities",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e8cf63ac-87cf-4e59-b0bf-e9527352b007-b-decagon-agent-capabilities-thumb.jpg"
      },
      {
        "title": "The complete AI customer service platform guide",
        "url": "https://decagon.ai/blog/ai-agent-assistance",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b6c0e353-3df1-4b99-abbb-684e93e2bb50-b-decagon-agent-assist-thumb.jpg"
      },
      {
        "title": "The AI Agent Engine",
        "url": "https://decagon.ai/blog/the-ai-agent-engine",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1266d8bd-308e-4e80-9349-591931587347-b-decagon-agent-engine-thumb.jpg"
      },
      {
        "title": "Decagon launches with $35m raised from Accel and a16z",
        "url": "https://decagon.ai/blog/series-a",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/23ee259b-e4ef-4440-97ef-e7b69029de01-b-decagon-series-a-thumb.jpg"
      },
      {
        "title": "From support to growth: The next evolution of AI agents",
        "url": "https://decagon.ai/blog/from-support-to-growth-the-next-evolution-of-ai-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/55260374-b44a-4b35-9ab1-d5981e879422-b-decagon-support-to-growth-thumb.jpg"
      },
      {
        "title": "Selecting AI chatbots for reliable customer service",
        "url": "https://decagon.ai/blog/ai-chatbots-customer-service",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/26c21f09-fe55-406b-b839-b4de877024b4-b-decagon-chatbots-thumb.jpg"
      },
      {
        "title": "Best AI customer service software that actually resolves tickets",
        "url": "https://decagon.ai/blog/ai-customer-service",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1253ecde-6f79-4c6a-a8f1-841a8d785528-b-decagon-resolves-tickets-thumb.jpg"
      },
      {
        "title": "Build or buy? Navigating AI support agents",
        "url": "https://decagon.ai/blog/build-or-buy",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/35b16251-a59c-4ad3-afd2-38e6088bbfff-b-decagon-build-or-buy-thumb.jpg"
      },
      {
        "title": "The enterprise buyer's guide to conversational AI platforms",
        "url": "https://decagon.ai/blog/conversational-ai-platform-for-enterprise",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f6af2944-e969-45af-8788-a08ba51493ea-b-decagon-buyers-guide-thumb.jpg"
      },
      {
        "title": "Deutsche Telekom chooses Decagon to power concierge CX",
        "url": "https://decagon.ai/blog/decagon-and-deutsche-telekom",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e0cea0b4-4030-4f45-a0e7-f76e51fd39e2-b-decagon-deutsche-telekom-thumb.jpg"
      }
    ]
  },
  {
    "company": "Glean",
    "articles": [
      {
        "title": "The definitive guide to AI-based enterprise search for 2025",
        "url": "https://www.glean.com/blog/the-definitive-guide-to-ai-based-enterprise-search-for-2025",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d9eeed52-c090-45b2-90ec-d16f6fa3fc75-b-glean-search-guide-2025-thumb.jpg"
      },
      {
        "title": "AI agents in the enterprise: Key benefits and real-world applications",
        "url": "https://www.glean.com/blog/ai-agents-enterprise",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4cf3e3b4-bc0a-4262-a3c3-332bcfbf7754-b-glean-agents-enterprise-thumb.jpg"
      },
      {
        "title": "Enterprise AI Search: Revolutionizing information retrieval",
        "url": "https://www.glean.com/blog/enterprise-ai-search-rag",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/97d4a2a7-b701-4bbc-aebf-9e5f7cd89f2f-b-glean-search-rag-thumb.jpg"
      },
      {
        "title": "Agentic reasoning: The future of Work AI",
        "url": "https://www.glean.com/blog/agentic-reasoning-future-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/43d1b298-0a97-4c84-a389-748ee3dd0529-b-glean-agentic-reasoning-thumb.jpg"
      },
      {
        "title": "Glean introduces Glean Agents and advances the Work AI platform",
        "url": "https://www.glean.com/blog/glean-agents-launch-blog",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/2bfcd8b0-c882-423f-8ab9-916a40fbfd95-b-glean-agents-launch-thumb.jpg"
      },
      {
        "title": "Building agentic reasoning for the modern workspace",
        "url": "https://www.glean.com/blog/agentic-reasoning-modern-work",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/381be01a-dbef-443d-989a-a78849536e1a-b-glean-agentic-modern-work-thumb.jpg"
      },
      {
        "title": "From reactive to proactive: Agentic AI for HR and finance",
        "url": "https://www.glean.com/blog/workday-rising-agentic-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/0eed98f4-6c9e-4c78-bac9-e1b239fced45-b-glean-workday-rising-thumb.jpg"
      },
      {
        "title": "Glean Launches the Work AI Institute, Unveils Autonomous Agents",
        "url": "https://www.glean.com/press/glean-launches-the-work-ai-institute-unveils-autonomous-agents-built-on-glean-enterprise-context-to-operationalize-ai-at-work",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d7d5d7aa-b834-4197-b3e2-9721ee7a9efa-b-glean-work-ai-institute-thumb.jpg"
      },
      {
        "title": "Introducing Glean Agents, Making AI Agents a Reality for Enterprises",
        "url": "https://www.glean.com/press/glean-makes-horizontal-ai-agents-for-enterprises-expands-work-ai-with-glean-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/70eb6bb3-ccd5-4453-a609-594b248ca65a-b-glean-introducing-agents-thumb.jpg"
      },
      {
        "title": "Glean Achieves $100M ARR in Three Years, Delivering True AI ROI",
        "url": "https://www.glean.com/press/glean-achieves-100m-arr-in-three-years-delivering-true-ai-roi-to-the-enterprise",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e7ecd0ec-bc1d-4c5b-bea4-6c71ac89a9a3-b-glean-100m-arr-thumb.jpg"
      }
    ]
  },
  {
    "company": "Writer",
    "articles": [
      {
        "title": "The future of enterprise AI: A fireside chat with CEO May Habib",
        "url": "https://writer.com/blog/enterprise-ai-future-fireside/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/09c06fc8-2950-49c4-bdf7-ca0d7515027e-b-writer-fireside-thumb.jpg"
      },
      {
        "title": "AI guardrails: How to build safe enterprise generative AI, from day one",
        "url": "https://writer.com/blog/ai-guardrails/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/7c80b0e7-8e0c-4e2d-a21f-7ef73a4c563d-b-writer-guardrails-thumb.jpg"
      },
      {
        "title": "Enterprise generative AI implementation: Key roles to drive success",
        "url": "https://writer.com/blog/generative-ai-implementation/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f7f7620f-e56a-4394-9ec3-5ded1c50a8cf-b-writer-implementation-thumb.jpg"
      },
      {
        "title": "How enterprises can map generative AI use cases for fast, safe implementation",
        "url": "https://writer.com/blog/mapping-generative-ai-use-cases/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cd6dd7ec-c854-4ae2-962d-8b1361c2d3d2-b-writer-mapping-usecases-thumb.jpg"
      },
      {
        "title": "Generative AI in the enterprise 2024: Survey results",
        "url": "https://writer.com/blog/generative-ai-survey-takeaways/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/fedef31d-e175-468d-abbc-0e62f82e2fbb-b-writer-survey-2024-thumb.jpg"
      },
      {
        "title": "Key findings from our 2025 enterprise AI adoption report",
        "url": "https://writer.com/blog/enterprise-ai-adoption-survey/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/abc5eb6b-8280-4cb3-97f0-c1c21a793dac-b-writer-adoption-2025-thumb.jpg"
      },
      {
        "title": "Writer delivers content trained by your best content",
        "url": "https://writer.com/blog/generative-ai-capabilities/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c272325c-c0c5-4247-bb77-1ccb3425f584-b-writer-capabilities-thumb.jpg"
      },
      {
        "title": "AI ROI calculator: From generative to agentic AI success in 2025",
        "url": "https://writer.com/blog/roi-for-generative-ai/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/3ec481d0-6b3e-454c-9caa-01e4fd399d4c-b-writer-roi-thumb.jpg"
      },
      {
        "title": "WRITER Launches AI HQ to Revolutionize Agentic Work in the Enterprise",
        "url": "https://writer.com/blog/writer-ai-hq-press-release/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/696a14cc-71af-4a0f-831a-65d22490d194-b-writer-ai-hq-thumb.jpg"
      },
      {
        "title": "Agentic AI for marketing teams: content generation to campaign orchestration",
        "url": "https://writer.com/blog/agentic-ai-marketing/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/3f5ed5fc-8575-4b28-93fb-93218bd09bba-b-writer-agentic-marketing-thumb.jpg"
      },
      {
        "title": "AI agents in the enterprise",
        "url": "https://writer.com/blog/ai-agents/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/29cf777b-2dd9-46a6-81d8-ec9640e62f19-b-writer-ai-agents-thumb.jpg"
      },
      {
        "title": "Enterprise guide to agent washing: Avoid million-dollar AI agent mistakes",
        "url": "https://writer.com/blog/agent-washing/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1f13fb45-161c-4b3e-89f8-ac0e8ccb695f-b-writer-agent-washing-thumb.jpg"
      },
      {
        "title": "Agentic AI adoption: A leader's roadmap to governance and training",
        "url": "https://writer.com/blog/responsible-ai-adoption-and-training/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c9b1c781-25f4-49ad-b621-f8866fc8db46-b-writer-responsible-adoption-thumb.jpg"
      },
      {
        "title": "WRITER Launches New AI Agent Experience for Everyday Work",
        "url": "https://writer.com/blog/writer-agent-press-release/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ee7b4b02-2b26-49da-b01c-0cf00e379b46-b-writer-agent-launch-thumb.jpg"
      },
      {
        "title": "Introducing WRITER Agent: A new agent design pattern for enterprise scale",
        "url": "https://writer.com/blog/writer-agent/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/fdaaf4b9-b960-4e90-9f5f-366439d3405c-b-writer-agent-pattern-thumb.jpg"
      }
    ]
  },
  {
    "company": "Sequoia Capital",
    "articles": [
      {
        "title": "Generative AI: A Creative New World",
        "url": "https://sequoiacap.com/article/generative-ai-a-creative-new-world/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4cc031f4-5f03-4468-99d9-3fb6d648d2aa-b-sequoia-creative-new-world-thumb.jpg"
      },
      {
        "title": "Generative AI's Act Two",
        "url": "https://sequoiacap.com/article/generative-ai-act-two/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/83b7c7ac-a04e-4d5d-a216-76d694185015-b-sequoia-act-two-thumb.jpg"
      },
      {
        "title": "Generative AI's Act o1: The Reasoning Era Begins",
        "url": "https://sequoiacap.com/article/generative-ais-act-o1/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b7e13c0d-ac85-43ba-ab26-5147ef549c3e-b-sequoia-act-o1-thumb.jpg"
      },
      {
        "title": "2026: This is AGI",
        "url": "https://sequoiacap.com/article/2026-this-is-agi/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f168692c-0500-4b61-a335-9e4adba5cefd-b-sequoia-this-is-agi-thumb.jpg"
      },
      {
        "title": "AI 50: Companies of the Future",
        "url": "https://sequoiacap.com/article/ai-50-2024/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/54ebff33-a50e-431a-b935-edb50361755d-b-sequoia-ai-50-thumb.jpg"
      },
      {
        "title": "Sequoia Capital AI Ascent 2025 Conference",
        "url": "https://sequoiacap.com/article/ai-ascent-2025/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e64ee595-87c4-4542-b477-3855fd756667-b-sequoia-ai-ascent-2025-thumb.jpg"
      },
      {
        "title": "Bringing Generative AI to Healthcare",
        "url": "https://sequoiacap.com/article/generative-ai-for-healthcare-perspective/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/7f311a55-db6e-4e60-9ba9-26800fbf8342-b-sequoia-healthcare-thumb.jpg"
      },
      {
        "title": "The Compound Lever: AI for Software Engineering",
        "url": "https://sequoiacap.com/article/ai-compound-lever/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e152cb0a-291b-47fc-b115-2f55adaef9e6-b-sequoia-compound-lever-thumb.jpg"
      },
      {
        "title": "AI in 2025: Building Blocks Firmly in Place",
        "url": "https://sequoiacap.com/article/ai-in-2025/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/04ff0160-aada-47a8-97a6-aeb0013fd83e-b-sequoia-ai-in-2025-thumb.jpg"
      },
      {
        "title": "AI in 2024: From Big Bang to Primordial Soup",
        "url": "https://sequoiacap.com/article/ai-in-2024/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1c80a63b-bd2a-4cfc-8173-9588613cf5fc-b-sequoia-ai-in-2024-thumb.jpg"
      }
    ]
  },
  {
    "company": "Menlo Ventures",
    "articles": [
      {
        "title": "2025: The State of Generative AI in the Enterprise",
        "url": "https://menlovc.com/perspective/2025-the-state-of-generative-ai-in-the-enterprise/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/08297bdc-f5cc-42e5-b9c1-57f6ce54f465-b-menlo-soga-2025-thumb.jpg"
      },
      {
        "title": "2024: The State of Generative AI in the Enterprise",
        "url": "https://menlovc.com/2024-the-state-of-generative-ai-in-the-enterprise/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/bf69372b-c52b-4d87-b17d-f226010e9a7a-b-menlo-soga-2024-thumb.jpg"
      },
      {
        "title": "2023: The State of Generative AI in the Enterprise",
        "url": "https://menlovc.com/2023-the-state-of-generative-ai-in-the-enterprise-report/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/82599d37-5249-4c1a-9634-39db4818fc6d-b-menlo-soga-2023-thumb.jpg"
      },
      {
        "title": "2025 Mid-Year LLM Market Update: Foundation Model Landscape + Economics",
        "url": "https://menlovc.com/perspective/2025-mid-year-llm-market-update/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d2ba17ff-f60a-4b09-b3b6-1c7b931a2373-b-menlo-llm-midyear-thumb.jpg"
      },
      {
        "title": "2025: The State of Consumer AI",
        "url": "https://menlovc.com/perspective/2025-the-state-of-consumer-ai/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/142fa298-0820-4c65-820a-7c8ae6c7c5a7-b-menlo-consumer-ai-thumb.jpg"
      }
    ]
  },
  {
    "company": "BCG",
    "articles": [
      {
        "title": "Are You Generating Value from AI? The Widening Gap",
        "url": "https://www.bcg.com/publications/2025/are-you-generating-value-from-ai-the-widening-gap",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/6c131590-17b1-4218-ada1-5a62cbb8ddc3-b-bcg-value-gap-thumb.jpg"
      },
      {
        "title": "From Potential to Profit: Closing the AI Impact Gap",
        "url": "https://www.bcg.com/publications/2025/closing-the-ai-impact-gap",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/28ef3a50-ac46-4406-9420-c825a89041aa-b-bcg-impact-gap-thumb.jpg"
      },
      {
        "title": "How Agents Are Accelerating the Next Wave of AI Value Creation",
        "url": "https://www.bcg.com/publications/2025/agents-accelerate-next-wave-of-ai-value-creation",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/80ab4758-ed3b-4715-a69c-3bdfe1ff378c-b-bcg-agents-value-thumb.jpg"
      },
      {
        "title": "Where's the Value in AI?",
        "url": "https://www.bcg.com/publications/2024/wheres-value-in-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/6e39884c-00d2-44eb-94d0-808bd3dece4b-b-bcg-wheres-value-thumb.jpg"
      },
      {
        "title": "AI-First Enterprise Operations: Reinventing the Operating System of Work",
        "url": "https://www.bcg.com/publications/2026/reinventing-the-operating-system-of-work-with-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/181fadd2-4fcb-4e6e-9543-716531903103-b-bcg-operating-system-thumb.jpg"
      }
    ]
  },
  {
    "company": "OpenAI",
    "articles": [
      {
        "title": "Customer stories",
        "url": "https://openai.com/business/customer-stories/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/02d0fb8c-26dc-418e-876f-47c884ca1bc1-b-openai-customer-stories-thumb.jpg"
      },
      {
        "title": "1 million business customers: the fastest-growing business platform in history",
        "url": "https://openai.com/index/1-million-businesses-putting-ai-to-work/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/9413301b-765d-4bf4-83d1-caffbd3b046f-b-openai-1m-businesses-thumb.jpg"
      }
    ]
  },
  {
    "company": "Zapier",
    "articles": [
      {
        "title": "Zapier Agents: Combine AI agents with automation",
        "url": "https://zapier.com/blog/zapier-agents-guide/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cca0b058-253a-4517-9245-257702b2ef0c-b-zapier-agents-guide-thumb.jpg"
      },
      {
        "title": "AI workflows: How to use AI in your business",
        "url": "https://zapier.com/blog/ai-workflows/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ead5d209-0a63-4a6e-a3c0-5aeeb76b34e7-b-zapier-ai-workflows-thumb.jpg"
      },
      {
        "title": "AI agents for business automation",
        "url": "https://zapier.com/blog/ai-agents-for-business/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f31ec34c-5341-457c-8458-7234f27ecff9-b-zapier-agents-business-thumb.jpg"
      },
      {
        "title": "AI at Zapier: How we use AI to streamline work",
        "url": "https://zapier.com/blog/how-zapier-uses-ai/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c04ffbed-ba58-4664-b16e-66228d62aa62-b-zapier-how-we-use-ai-thumb.jpg"
      },
      {
        "title": "Zapier's AI tools",
        "url": "https://zapier.com/blog/zapier-ai-guide/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/68b23913-417c-4c48-b740-e8b5ce61f325-b-zapier-ai-guide-thumb.jpg"
      },
      {
        "title": "8 AI agent use cases and examples in the workplace",
        "url": "https://zapier.com/blog/ai-agent-use-cases/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d478d163-c0d9-4bb9-8836-c1d00a0d6349-b-zapier-agent-usecases-thumb.jpg"
      },
      {
        "title": "New AI workflow features to build powerful systems",
        "url": "https://zapier.com/blog/ai-workflow-features/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/32ac3979-6de9-426a-8624-2766b1bf9136-b-zapier-workflow-features-thumb.jpg"
      },
      {
        "title": "The new Zapier Agents: scalable, organized AI automation",
        "url": "https://zapier.com/blog/zapier-agents-pods-dashboards/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/30e3d5a8-a11c-4845-a210-1d43be71a5ea-b-zapier-agents-pods-thumb.jpg"
      },
      {
        "title": "12 AI automation examples from teams doing it right",
        "url": "https://zapier.com/blog/ai-automation-examples/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b13000ee-fd9e-4fc3-b74b-d66f1f2a9fae-b-zapier-automation-examples-thumb.jpg"
      }
    ]
  },
  {
    "company": "Wonderful",
    "articles": [
      {
        "title": "Wonderful Launches in the Netherlands",
        "url": "https://www.wonderful.ai/blog-articles/wonderful-netherlands",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/622b36fb-1085-4327-9e3d-ef79690270d4-b-wonderful-netherlands-thumb.jpg"
      },
      {
        "title": "How a leading European telecom tripled AI call deflection in 8 weeks",
        "url": "https://www.wonderful.ai/blog-articles/ote",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1adcbe3a-58a1-4d6a-bb9f-bf336e9f6bab-b-wonderful-ote-thumb.jpg"
      },
      {
        "title": "Wonderful | Applied AI for the enterprise",
        "url": "https://www.wonderful.ai/about-us",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5aa61643-ec51-4725-b453-27536fb8ba78-b-wonderful-about-thumb.jpg"
      }
    ]
  },
  {
    "company": "a16z",
    "articles": [
      {
        "title": "Hi, AI: Our Thesis on AI Voice Agents",
        "url": "https://a16z.com/ai-voice-agents/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d5c90f18-0c54-44a2-9d2f-a603949c1d78-b-a16z-voice-agents-thumb.jpg"
      },
      {
        "title": "AI Voice Agents: 2025 Update",
        "url": "https://a16z.com/ai-voice-agents-2025-update/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/73827de8-84b2-49e6-aacb-297813c4a927-b-a16z-voice-agents-2025-thumb.jpg"
      },
      {
        "title": "Big Ideas in Tech for 2025",
        "url": "https://a16z.com/big-ideas-in-tech-2025/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e48da4b9-a872-4c3b-bb8b-1be68f472134-b-a16z-big-ideas-2025-thumb.jpg"
      },
      {
        "title": "Voice AI Will Change How We Bank",
        "url": "https://a16z.com/newsletter/voice-ai-will-change-how-we-bank-february-2025-fintech-newsletter/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/9fa63fdf-be62-4360-9a45-35d0bbddf020-b-a16z-voice-bank-thumb.jpg"
      }
    ]
  },
  {
    "company": "McKinsey QuantumBlack",
    "articles": [
      {
        "title": "How COOs maximize operational impact from gen AI and agentic AI",
        "url": "https://www.mckinsey.com/capabilities/operations/our-insights/how-coos-maximize-operational-impact-from-gen-ai-and-agentic-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e1ed4f2d-7021-4fbf-b6e2-b7083dc8767e-b-mck-coos-thumb.jpg"
      }
    ]
  }
];
